var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLegalEntityMark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 48,
    viewBox: "0 0 36 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.1056 39.4472L2.89443 46.5528C1.56463 47.2177 0 46.2507 0 44.7639V2C0 0.895431 0.895432 0 2 0H34C35.1046 0 36 0.895432 36 2V44.7639C36 46.2507 34.4354 47.2177 33.1056 46.5528L18.8944 39.4472C18.3314 39.1657 17.6686 39.1657 17.1056 39.4472Z",
    fill: "#FF0508"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10 16C10 14.8954 10.8954 14 12 14H24C25.1046 14 26 14.8954 26 16V29C26 29.5523 25.5523 30 25 30C24.4477 30 24 29.5523 24 29V16L12 16V29C12 29.5523 11.5523 30 11 30C10.4477 30 10 29.5523 10 29V16Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.5 14C24.5 14.8284 23.8284 15.5 23 15.5H13C12.1716 15.5 11.5 14.8284 11.5 14C11.5 13.1716 12.1716 12.5 13 12.5H23C23.8284 12.5 24.5 13.1716 24.5 14Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.5 13C21.5 13.8284 20.8284 14.5 20 14.5L16 14.5C15.1716 14.5 14.5 13.8284 14.5 13C14.5 12.1716 15.1716 11.5 16 11.5L20 11.5C20.8284 11.5 21.5 12.1716 21.5 13Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18 7C18.8284 7 19.5 7.67157 19.5 8.5V13C19.5 13.8284 18.8284 14.5 18 14.5C17.1716 14.5 16.5 13.8284 16.5 13V8.5C16.5 7.67157 17.1716 7 18 7Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14 19C14 18.4477 14.4477 18 15 18H21C21.5523 18 22 18.4477 22 19C22 19.5523 21.5523 20 21 20H15C14.4477 20 14 19.5523 14 19Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14 23C14 22.4477 14.4477 22 15 22H21C21.5523 22 22 22.4477 22 23C22 23.5523 21.5523 24 21 24H15C14.4477 24 14 23.5523 14 23Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14 27C14 26.4477 14.4477 26 15 26H21C21.5523 26 22 26.4477 22 27C22 27.5523 21.5523 28 21 28H15C14.4477 28 14 27.5523 14 27Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLegalEntityMark);
export default __webpack_public_path__ + "static/media/LegalEntityMark.8f3e117bd7e2a6941c26de33368e2424.svg";
export { ForwardRef as ReactComponent };